import { ControllerFlowAPI, PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';

const DEFAULT_LOCALE = 'en-US';

export function getLocale(flowAPI: PlatformControllerFlowAPI | ControllerFlowAPI) {
  const { wixCodeApi } = flowAPI.controllerConfig;
  return wixCodeApi.site.regionalSettings ?? DEFAULT_LOCALE;
}
